import { render, staticRenderFns } from "./PermissionNameGeneratorHandler.vue?vue&type=template&id=3459ffee"
import script from "./PermissionNameGeneratorHandler.vue?vue&type=script&lang=js"
export * from "./PermissionNameGeneratorHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports